<div class="container-fluid">
  <div class="row mb-15">
    <div class="col-lg-10">
      <h4 class="mb-0 font-size-18">Welcome To SGLD Dashboard!</h4>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-6">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-3">Smart Leak Devices Connection Status</h4>
          <div *ngIf="totalDeviceCOunt > 0">
            <p class="text-primary font-size-14">
             Total Smart Leak Devices Connection: {{ totalDeviceCOunt }}
            </p>

            <kendo-chart style="height: 203px;">
              <kendo-chart-series>
                <kendo-chart-series-item type="pie" [data]="deviceCOuntinfographData">
                  <kendo-chart-series-item-labels
                    [content]="labelContent"
                    [visible]="true"
                    position="center"
                    background="transparent">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>

              <kendo-chart-tooltip>
                <ng-template kendoChartTooltipTemplate let-point="point">
                  {{ point.category }}: {{ point.value }} ({{ point.percentage }}%)
                </ng-template>
              </kendo-chart-tooltip>
            </kendo-chart>

            <div>
              <div *ngFor="let series of deviceCOuntinfographData">
                <span>
                  <i class="bx bxs-circle" [ngStyle]="{ color: series.color }"></i>
                  <span class="font-size-12 font-weight-bolder ms-1">
                    {{ series?.name }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div *ngIf="deviceCountStatusLoading"
            class="d-flex align-items-center justify-content-center text-center sgldGraph">
            <p>Loading......</p>
          </div>
          <div *ngIf="deviceCountStatusNoDate"
            class="d-flex align-items-center justify-content-center text-center device_cont_no_data">
            <p>No data available</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-6">
      <div class="card">
        <div class="card-body" style="width: 100%; overflow: hidden">
          <h4 class="card-title mb-3">Leak Detection Identifier</h4>

          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="col-xl-5">
              <p class="text-primary font-size-14 mb-0">
                Total Notification count : {{ totalNotificationCount }}
              </p>
              
            </div>
            <div class="d-flex justify-content-end col-xl-7">
              <div class="d-flex justify-content-between w-200">
                <div class="ng-select-container ms-auto">
                  <ng-select
                    [items]="leakmonths"
                    [clearable]="false"
                    [deselectOnClick]="false"
                    placeholder="Select Month"
                    (change)="leakNotificationselectionChange($event)"
                    id="billingType"
                    [(ngModel)]="isSelectMonths"
                    [multiple]="false">
                  </ng-select>
                </div>
              </div>
            </div>
          </div>

          @if(isLeakChartShow){
          <div *ngIf="totalNotificationCount > 0">
            <div style="overflow-x: auto; height: 278px">
              <div *ngIf="deviceNotificationGraphDataLoding" class="chart-loader">
                <div class="spinner"></div>
              </div>

              <div *ngIf="deviceNotificationGraphdata && deviceNotificationGraphdata.length > 0">
                <apx-chart
                  #chart
                  class="cursor-pointer"
                  [series]="chartOptions.series"
                  [colors]="chartOptions.colors"
                  [chart]="chartOptions.chart"
                  [xaxis]="chartOptions.xaxis"
                  [yaxis]="chartOptions.yaxis"
                  [dataLabels]="chartOptions.dataLabels"
                  [stroke]="chartOptions.stroke"
                  [markers]="chartOptions.markers"
                  [tooltip]="chartOptions.tooltip"
                  [fill]="chartOptions.fill">
                </apx-chart>
              </div>
            </div>
          </div>
          <div *ngIf="totalNotificationCount == 0"
            class="card-no-data text-center d-flex justify-content-center align-items-center notification_cont_no_data">
            <p>No data available</p>
          </div>
          } @else {
          <div *ngIf="devicemonthlyNotificationGraphDataLoding" class="chart-loader">
            <div class="spinner"></div>
          </div>
          <div *ngIf="monthlydeviceNotificationGraphdata && monthlydeviceNotificationGraphdata.length">
            <kendo-chart style="height: 278px">
              <kendo-chart-series>
                <kendo-chart-category-axis>
                  <kendo-chart-category-axis-item [title]="{ text: 'Months' }">
                  </kendo-chart-category-axis-item>
                </kendo-chart-category-axis>

                <kendo-chart-value-axis>
                  <kendo-chart-value-axis-item [title]="{ text: 'Count' }">
                  </kendo-chart-value-axis-item>
                </kendo-chart-value-axis>
                <kendo-chart-series-item
                  [data]="monthlydeviceNotificationGraphdata"
                  field="value"
                  categoryField="category"
                  [colorField]="'colorString'"
                  [labels]="{ visible: true, content: labelContent }"
                  [visible]="seriesVisible"
                  [tooltip]="{ visible: true }"
                  [spacing]="1">
                </kendo-chart-series-item>
              </kendo-chart-series>

              <kendo-chart-legend position="bottom"></kendo-chart-legend>
            </kendo-chart>
          </div>
          <div *ngIf="monthlydeviceNotificationGraphdata && monthlydeviceNotificationGraphdata.length == 0"
            class="card-no-data text-center d-flex justify-content-center align-items-center notification_cont_no_data">
            <p>No data available</p>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>